<template>
  <svg id="icon-package" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-498.5-12.5h554v512h-554z"/>
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M11.079 3.292l5.2 2.6c.441.22.72.67.721 1.164v6.195a1.3 1.3 0 0 1-.722 1.163l-5.2 2.6a1.3 1.3 0 0 1-1.163 0l-5.2-2.6A1.3 1.3 0 0 1 4 13.244V7.056c0-.493.28-.944.722-1.163l5.2-2.6a1.3 1.3 0 0 1 1.157 0z"/>
        <path d="M4.208 6.354L10.5 9.5l6.292-3.146M10.5 17.144V9.5M7.25 4.625l6.5 3.25"/>
      </g>
    </g>
  </svg>
</template>
